import { createAction } from '@reduxjs/toolkit';

const setChainsSearchTermAction = 'industry/set-report-chains-search-term';
export const setChainsSearchSearchTerm = createAction<string, typeof setChainsSearchTermAction>(
    setChainsSearchTermAction,
);
